// extracted by mini-css-extract-plugin
export default {"overview":"Overview_overview__eOUIi","controls":"Overview_controls__qW5q9"};